import { type MaybeRef, toValue } from 'vue';

import {
  createBaremetalServer,
  deleteBaremetalServer,
  powerCycleBaremetalServer,
  powerOffBaremetalServer,
  powerOnBaremetalServer,
  reinstallBaremetalServer,
  renameBaremetalServer,
  resetBaremetalPassword,
  saveBaremetalTags,
} from './api';

export const createBaremetalServerMutation = () => ({
  mutationFn: createBaremetalServer,
});

export const powerOnBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: () => powerOnBaremetalServer(toValue(serverId)),
});

export const powerOffBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: () => powerOffBaremetalServer(toValue(serverId)),
});

export const powerCycleBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: () => powerCycleBaremetalServer(toValue(serverId)),
});

export const renameBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: (name: string) => renameBaremetalServer(toValue(serverId), name),
});

export const reinstallBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: (kickstart: string) => reinstallBaremetalServer(toValue(serverId), kickstart),
});

export const resetBaremetalPasswordMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: (password: string) => resetBaremetalPassword(toValue(serverId), password),
});

export const saveBaremetalTagsMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: (tags: string[]) => saveBaremetalTags(toValue(serverId), tags),
});

export const deleteBaremetalServerMutation = (serverId: MaybeRef<number>) => ({
  mutationFn: () => deleteBaremetalServer(toValue(serverId)),
});
